import React, {Suspense, useEffect, useState} from 'react';
import {useRegisteredComponent} from '@ey/voltron-core';
import config from '@ey/voltron-config';
import env from '../../../util/env';
import ErrorBoundary from './ErrorBoundary';

export default function RemoteComponent({
	id,
	loadingFallback = '',
	errorFallback = '',
	runtimeErrorFallback,
	onRuntimeError,
	onLoadError,
	onLoadSuccess,
	...props
}) {
	const {Component, errorLoading} = useRegisteredComponent(id);
	const [isServer, setIsServer] = useState(true);

	useEffect(() => {
		setIsServer(false);
	}, []);

	useEffect(() => {
		if (errorLoading && onLoadError) {
			onLoadError(errorLoading);
		}
		if (Component && onLoadSuccess) {
			onLoadSuccess();
		}

	}, [errorLoading, Component]);

	return isServer ? (
		loadingFallback
	) : (
		<ErrorBoundary id={id} fallback={runtimeErrorFallback || errorFallback} onError={onRuntimeError}>
			<Suspense fallback={loadingFallback}>
				{errorLoading ? (
					errorFallback
				) : Component ? (
							<Component
								loadingFallback={loadingFallback}
								federatedHostName={env.getFederatedHostName()}
								adConfig={config.ad}
								telemetry={false}
								runtimeErrorFallback={runtimeErrorFallback || errorFallback}
								onRuntimeError={onRuntimeError}								
								{...props}							
					/>
				) : (
					loadingFallback
				)}
			</Suspense>
		</ErrorBoundary>
	);
}
